import { OpenParserInputData } from '../openTypes';

const subscriptionTemplateData: OpenParserInputData = {
  status: 200,
  data: {
    generated_link: 'http://www.example.com',
    subscription: true,
    metrics_token: '0',
    storable: false,
    fields_duplication: {
      duplicate: false,
      payment_duplication: {
        allow: false,
        max_duplication: 0,
      },
      data: {},
    },
    merchant: {
      id: 1,
      name: 'Prueba',
      logo: null,
      colors: '{}',
      preferred_template: 0,
    },
    payment_request: {
      id: 'aaa',
      identifier: 'example-identifier',
      name: 'John Doe',
      email: 'example@mail.com',
      amount: 1000000,
      currency: null,
      blank_amount: false,
      has_iva: false,
      has_link_configurations: true,
      link_configurations: [],
      merchant_configurations: [],
      header: null,
    },
  },
};

export default subscriptionTemplateData;
